import React from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import Introduce from "../../components/Introduce";
import ProductCard from "../../components/ProductCard";
import PeopleCard from "../../components/PeopleCard";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.css";
import {
  appInfoPhoneList,
  appInfoPhoneFirstList,
  appInfoDesktopFirstList,
  appInfoPhoneSecondList,
  appInfoDesktopSecondList,
  coreTeamList,
} from "./config";
import _ from "lodash";
import useIsPhone from "../../hooks/useIsPhone";
import { Rem } from "@fe_utils/fe_sdk_base";
import { LeftIcon, RightIcon } from "../../icons";
import AutoScrollingScrollView from "../../components/AutoScrollingScrollView";

SwiperCore.use([Autoplay, Navigation, Pagination]);

const LaiYinSeries = () => {
  const isPhone = useIsPhone();
  if (isPhone) {
    Rem.init(37.5, 1, false);
  } else {
    Rem.resetRem(50);
  }
  return (
    <Wrapper>
      <img
        className="head_bg"
        src={
          isPhone
            ? require("./images/laiyin_series_head_bg.png")
            : require("./images/laiyin_series_head_desktop_bg.png")
        }
        alt=""
      />
      <Introduce
        src={require("./images/our_products_title.png")}
        backgroundColor={"#FFFFFF"}
        alt={"我们的产品"}
      >
        <OurProducts>
          <AutoScrollingScrollView>
            {_.map(appInfoPhoneList, ([item1, item2]) => (
              <ProductCardWrapper key={item1.appName}>
                <ProductCard {...item1} key={item1.appName}></ProductCard>
                <ProductCard {...item2} key={item2.appName}></ProductCard>
              </ProductCardWrapper>
            ))}
          </AutoScrollingScrollView>
          {/* {isPhone ? (
            <>
              <ProductSwiper
                spaceBetween={24}
                slidesPerView={"auto"}
                centeredSlides={true}
                loop={true}
                loopedSlides={7}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                pagination={{
                  clickable: true,
                }}
              >
                {_.map(appInfoPhoneFirstList, (item) => (
                  <SwiperSlide key={item.appName}>
                    <ProductCard {...item}></ProductCard>
                  </SwiperSlide>
                ))}
              </ProductSwiper>
              <ProductSwiper
                spaceBetween={24}
                slidesPerView={"auto"}
                centeredSlides={true}
                loop={true}
                loopedSlides={7}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                pagination={{
                  clickable: true,
                }}
              >
                {_.map(appInfoPhoneSecondList, (item) => (
                  <SwiperSlide key={item.appName}>
                    <ProductCard {...item}></ProductCard>
                  </SwiperSlide>
                ))}
              </ProductSwiper>
            </>
          ) : (
            <>
              <SwiperDesktopWrapper>
                <ArrowFirstWrapperLeft>
                  <LeftIcon fill="#525459" size={16} />
                </ArrowFirstWrapperLeft>
                <ProductSwiper
                  spaceBetween={24}
                  slidesPerView={4}
                  navigation={{
                    prevEl: `${ArrowFirstWrapperLeft}`,
                    nextEl: `${ArrowFirstWrapperRight}`,
                  }}
                  loop={true}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  pagination={{
                    clickable: true,
                  }}
                >
                  {_.map(appInfoDesktopFirstList, (item) => (
                    <SwiperSlide key={item.appName}>
                      <ProductCard {...item}></ProductCard>
                    </SwiperSlide>
                  ))}
                </ProductSwiper>
                <ArrowFirstWrapperRight>
                  <RightIcon fill="#525459" size={16} />
                </ArrowFirstWrapperRight>
              </SwiperDesktopWrapper>
              <SwiperDesktopWrapper>
                <ArrowSecondWrapperLeft>
                  <LeftIcon fill="#525459" size={16} />
                </ArrowSecondWrapperLeft>
                <ProductSwiper
                  spaceBetween={24}
                  slidesPerView={"auto"}
                  loop={true}
                  loopedSlides={8}
                  autoplay={{ delay: 3000, disableOnInteraction: false }}
                  slidesPerGroup={4}
                  navigation={{
                    prevEl: `${ArrowSecondWrapperLeft}`,
                    nextEl: `${ArrowSecondWrapperRight}`,
                  }}
                  pagination={{
                    clickable: true,
                  }}
                >
                  {_.map(appInfoDesktopSecondList, (item) => (
                    <SwiperSlide key={item.appName}>
                      <ProductCard {...item}></ProductCard>
                    </SwiperSlide>
                  ))}
                </ProductSwiper>
                <ArrowSecondWrapperRight>
                  <RightIcon fill="#525459" size={16} />
                </ArrowSecondWrapperRight>
              </SwiperDesktopWrapper>
            </>
          )} */}
        </OurProducts>
      </Introduce>
      <Introduce
        src={require("./images/about_us_title.png")}
        backgroundColor={"#FFFCF5"}
        alt={"公司介绍"}
      >
        <CompanyProfile>
          <div className="laiyin_introduce">
            <span>来音</span>
            是中国知名的音乐教育科技品牌，致力于通过科技实现音乐教育平权，让中国成为音乐教育强国。来音将先进的音乐教育理念融入到App中，不断创新产品体验，让学音乐变得更高效更有趣。来音已累计帮助超3000万用户，赢得了用户与行业的高度认可。
            <br /> <br />
            在推动音乐教育事业发展的进程中，来音积极联动学校、乐器厂商、出版社等产业上下游合作伙伴，凝聚行业力量，共同为音乐教育的创新发展贡献智慧与力量。
            <br /> <br />
            “来音“是北京夕航科技旗下品牌。夕航科技成立于2018年，是国家高新技术企业、北京市“专精特新”企业，拥有近百项核心知识产权，在成立之初就获得了国内知名投资机构的投资。
          </div>
          <img
            className="certificate"
            src={require("./images/certificate.png")}
            alt=""
          />
        </CompanyProfile>
      </Introduce>
      <Introduce
        src={require("./images/core_team_title.png")}
        backgroundColor={"#FFFFFF"}
        alt={"来音团队介绍"}
      >
        <CoreTeam>
          {isPhone ? (
            <PeopleSwiper
              spaceBetween={24}
              slidesPerView={"auto"}
              centeredSlides={true}
              loop={true}
              loopedSlides={3}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              pagination={{
                clickable: true,
              }}
            >
              {_.map(coreTeamList, (item) => (
                <SwiperSlide key={item.name}>
                  <PeopleCard {...item}></PeopleCard>
                </SwiperSlide>
              ))}
            </PeopleSwiper>
          ) : (
            <div className="core_team_list">
              {_.map(coreTeamList, (item, index) => (
                <PeopleCard {...item} key={index}></PeopleCard>
              ))}
            </div>
          )}
          <div className="core_team_text">
            丰富的<span>专业</span>师资 · 国内外<span>名校</span> ·
            硕博学历占比超过<span>50%</span>
          </div>
          <img
            className="core_team_img"
            src={require("./images/core_team_img.png")}
            alt=""
          />
        </CoreTeam>
      </Introduce>
      <Introduce
        src={
          isPhone
            ? require("./images/responsibility_title_phone.png")
            : require("./images/responsibility_title.png")
        }
        backgroundColor={"#FFFCF5"}
        alt={"使命与社会责任"}
      >
        <MissionResponsibility>
          <MissionCard>
            <img src={require("./images/mission_img.png")} alt="" />
            <div>
              <div className="title">使命愿景</div>
              <div className="text">
                通过技术实现音乐教育平权
                <br />
                让中国成为音乐教育强国
              </div>
            </div>
          </MissionCard>
          <MissionCard className="reversal">
            <img src={require("./images/responsibility_img.png")} alt="" />
            <div>
              <div className="title">社会责任</div>
              <div className="text">
                践行音乐教育普惠，做每个人都用得起的音乐学习产品 <br />
                搭建学生与老师的链接平台，让学生找到好老师 <br />
                科技抚平城乡地域鸿沟，让优质音乐教育资源无界流动
              </div>
            </div>
          </MissionCard>
        </MissionResponsibility>
      </Introduce>
      <Introduce
        childrenIsWrapped={!isPhone}
        childrenWrapperStyle={{
          display: "flex",
          justifyContent: "center",
          paddingTop: isPhone ? "0" : "60px",
          paddingBottom: isPhone ? "0" : "92px",
        }}
        src={require("./images/company_honor_title.png")}
        backgroundColor={"#FFFFFF"}
        alt={"企业荣誉"}
      >
        <HonorCard>
          <img src={require("./images/company_honor_1.png")} alt="" />
          <div>
            <div className="honor">现代服务赛道·一等奖</div>
            <div className="honor">创业北京之星</div>
            <div className="text">“创业北京”创业创新大赛</div>
          </div>
        </HonorCard>
        <HonorCard>
          <img src={require("./images/company_honor_2.png")} alt="" />
          <div>
            <div className="honor">科技服务及其他行业·二等奖</div>
            <div className="honor">企业组·TOP 150</div>
            <div className="text">“创客北京2025”创新创业大赛</div>
          </div>
        </HonorCard>
        <HonorCard>
          <img src={require("./images/company_honor_3.png")} alt="" />
          <div>
            <div className="honor">先锋共建</div>
            <div className="text">HGDC·2024 荣耀开发者大会</div>
          </div>
        </HonorCard>
        <HonorCard style={{ marginBottom: isPhone ? "28px" : "0" }}>
          <img src={require("./images/company_honor_4.png")} alt="" />
          <div>
            <div className="honor">亚军</div>
            <div className="text">2025届科大讯飞AI开发者大赛</div>
          </div>
        </HonorCard>
      </Introduce>
      <Introduce
        src={require("./images/partners_title.png")}
        backgroundColor={"#FFFCF5"}
        alt={"合作伙伴"}
      >
        <PartnersImg src={require("./images/partners_img.png")} alt="" />
      </Introduce>
    </Wrapper>
  );
};

export default LaiYinSeries;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  > .head_bg {
    width: 100%;
  }
`;
const OurProducts = styled.div`
  margin-top: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const ProductCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  > div {
    margin: 12px;
  }
`;
const ProductSwiper = styled(Swiper)`
  width: 100%;
  margin: 0;
  overflow: hidden;
  > .swiper-wrapper {
    width: 260px;
    height: 505px;
    > .swiper-slide {
      width: 100%;
    }
  }
  > .swiper-pagination {
    z-index: 9999;
    position: absolute;
    top: 420px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #2c2e34;
      border-radius: 3px;
      opacity: 0.1;
      margin-right: 8px;
      transition: all 0.3s ease-in-out;
      &:last-child {
        margin-right: 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      height: 6px;
      background: #ffab18;
      border-radius: 3px;
      opacity: 1;
    }
  }
  ${breakpoint("desktop")`
     display: flex;
     align-items: center;
     margin: 0;
     padding: 12px;
     width: 1136px;  
  `}
`;
const SwiperDesktopWrapper = styled.div`
  margin: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ScrollView = styled.div`
  overflow-x: scroll;
  width: 100%;
  display: flex;
  align-items: center;
  > div {
    margin: 12px;
    flex-shrink: 0; /* 防止子元素被压缩 */
  }
  &::-webkit-scrollbar {
    display: none;
  }

  ${breakpoint("desktop")`
    width: 1136px;
  `}
`;
const ArrowFirstWrapperLeft = styled.div`
  margin-top: -50px;
  width: 47px;
  height: 47px;
  border-radius: 50%;
  background: rgba(44, 46, 52, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: rgba(44, 46, 52, 0.1);
  }
`;
const ArrowFirstWrapperRight = styled.div`
  margin-top: -50px;
  width: 47px;
  height: 47px;
  border-radius: 50%;
  background: rgba(44, 46, 52, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: rgba(44, 46, 52, 0.1);
  }
`;
const ArrowSecondWrapperLeft = styled.div`
  margin-top: -50px;
  width: 47px;
  height: 47px;
  border-radius: 50%;
  background: rgba(44, 46, 52, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: rgba(44, 46, 52, 0.1);
  }
`;
const ArrowSecondWrapperRight = styled.div`
  margin-top: -50px;
  width: 47px;
  height: 47px;
  border-radius: 50%;
  background: rgba(44, 46, 52, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: rgba(44, 46, 52, 0.1);
  }
`;
const PeopleSwiper = styled(Swiper)`
  width: 100%;
  margin: 0;
  overflow: hidden;
  > .swiper-wrapper {
    margin-top: 26px;
    width: 260px;
    height: 480px;
    > .swiper-slide {
      width: 100%;
    }
  }
  > .swiper-pagination {
    z-index: 9999;
    position: absolute;
    top: 438px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #2c2e34;
      border-radius: 3px;
      opacity: 0.1;
      margin-right: 8px;
      transition: all 0.3s ease-in-out;
      &:last-child {
        margin-right: 0;
      }
    }
    .swiper-pagination-bullet-active {
      width: 24px;
      height: 6px;
      background: #ffab18;
      border-radius: 3px;
      opacity: 1;
    }
  }
`;
const CompanyProfile = styled.div`
  margin-top: 26px;
  > .laiyin_introduce {
    text-align: justify;
    padding: 0 30px;
    font-size: 14px;
    line-height: 28px;
    > span {
      font-weight: 600;
      font-size: 28px;
      color: #2c2e34;
    }
  }
  > .certificate {
    margin-bottom: 48px;
    padding: 0 10px;
    width: 100%;
  }
  ${breakpoint("desktop")`
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    > .laiyin_introduce {
     width: 692px;
     line-height: 24px;
     margin-right: 16px;
     > span {
       font-size: 25px;
     }
    }
    > .certificate {
     width: 252px;
     }
    `}
`;
const CoreTeam = styled.div`
  > .core_team_text {
    text-align: center;
    font-weight: 700;
    font-size: 14px;
    color: #2c2e34;
    line-height: 20px;
    > span {
      color: #ff7f19;
    }
  }
  > .core_team_img {
    margin: 14px 0 32px 0;
    padding: 0 12px;
    width: 100%;
  }
  ${breakpoint("desktop")`
    > .core_team_list {
      margin: 59px 0 46px 0;
      display: flex;
      justify-content: center;
      > div {
        margin: 0 12px;
      }
    }
    > .core_team_text {
      font-size: 13px;
      line-height: 19px;
    }
    > .core_team_img {
      margin: 15px 0 0 0;
      padding: 0;
      width: 1174px;
    }
  `}
`;
const MissionResponsibility = styled.div`
  margin: 6px 0 72px 0;
  ${breakpoint("desktop")`
    margin: 54px 0 0 0;
  `}
`;
const MissionCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;
  > img {
    width: 100%;
  }
  > div {
    height: 139px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    > .title {
      margin-top: 12px;
      font-weight: 700;
      font-size: 18px;
      color: #2c2e34;
      line-height: 25px;
    }
    > .text {
      margin-top: 7px;
      font-weight: 400;
      font-size: 14px;
      color: #2c2e34;
      line-height: 24px;
      text-align: center;
    }
  }
  ${breakpoint("desktop")`
    flex-direction: row;
    justify-content: center;
    width: 900px;
    margin-bottom: 61px;
    > img {   
     margin-right: 20px;
     width: 437px;
     height: 278px;
    }
    > div {
     display: flex;
     flex-direction: column;
     justify-content: center;
     width: 437px;
     height: 278px;
      > .title {
        margin-top: 0;
        font-size: 24px;
        width: 437px;
        text-align: left;
        line-height: 35px;
      }
      > .text {
        margin-top: 11px;
        width: 437px;
        text-align: left;
        line-height: 27px;
      }
    }
    &.reversal {
      flex-direction: row-reverse;
      > img {
        margin-right: 0;
        margin-left: 20px;
      }
      > div {
        > .title {
          text-align: right;
        }
        > .text {
          text-align: right;
        }
      }
    }
  `}
`;
const HonorCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 16px 12px 16px;
  > img {
    width: 100%;
  }
  > div {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    > .honor {
      font-weight: 600;
      font-size: 21px;
      color: #bb9861;
      line-height: 29px;
    }
    > .text {
      font-weight: 400;
      font-size: 14px;
      color: #2c2e34;
      line-height: 29px;
    }
  }
  ${breakpoint("desktop")`
    width: 266px;
    padding: 0px;
    margin: 0 12px;
    > div {
      margin-top: 9px;
      > .honor {
        font-size: 16px;
        line-height: 22px;
      }
      > .text {
        font-size: 11px;
        line-height: 23px;  
      }
    }
  `}
`;
const PartnersImg = styled.img`
  padding: 15px 11px 43px;
  width: 100%;
  ${breakpoint("desktop")`
    margin:45px 0 52px 0;
    padding: 0;
    width: 906px;
  `}
`;
